import { AppContext, VNode, createVNode, render } from 'vue'
import { VueComponent, VueComponentProps } from '../helpers'

export function renderComponent<C extends VueComponent, P extends VueComponentProps<C>>(
  el: HTMLElement,
  component: C,
  props: P,
  appContext?: AppContext,
) {
  let vnode: VNode | undefined = createVNode(component, props)
  if (appContext) vnode.appContext = { ...appContext }
  render(vnode, el)

  return () => {
    // destroy vnode
    render(null, el)
    vnode = undefined
  }
}
